const KEY = 'hitmap_session';

function uuid(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  // Polyfill UUID v4 (Math.random — не криптостойко, но для анонимного session_id хватает)
  // Сервер валидирует format, поэтому fallback должен соответствовать UUID v4.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

let cached: string | null = null;

// UUID v4 regex для миграции legacy session_id формата
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function getSessionId(): string {
  if (cached) return cached;
  try {
    const existing = localStorage.getItem(KEY);
    if (existing && UUID_RE.test(existing)) {
      cached = existing;
      return existing;
    }
    // Legacy non-UUID id (old prod) → пересоздаём
    const fresh = uuid();
    localStorage.setItem(KEY, fresh);
    cached = fresh;
    return fresh;
  } catch {
    // localStorage unavailable (private mode etc.)
    cached = uuid();
    return cached;
  }
}
